export default function (Component) {
      Component.options.__docs = "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n```jsx\n  <mks-field-error error=\"There is an error with this field.\"></mks-field-error>\n  ```\n"
    }